import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterOutlet } from '@angular/router';
import { I18nService, LoggerService } from '@itavan/lib/core/services';
import { SupabaseSession } from '@itavan/lib/core/supabase';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../environments/environment';
import { APP_VERSION } from '../../../environments/version';

@Component({
  selector: 'app-layout-default',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    TranslocoPipe,
  ],
  templateUrl: './layout-default.html',
})
export class LayoutDefault {
  authService = inject(SupabaseSession);
  public i18n = inject(I18nService);
  private router = inject(Router);
  private logger = inject(LoggerService);

  public appVersion = `${APP_VERSION}${environment.app.env}`;

  constructor() {
    this.logger.log(this.authService.currentSession);
  }

  async logout() {
    try {
      await this.authService.signOut();
      this.router.navigate(['/login']);
    } catch (error) {
      this.logger.error('Error al cerrar sesión:', error);
    }
  }
}
